<app-grid
  *ngIf="(gridColumns$ | async) && (gridOptions$ | async)"
  [data]="gridData"
  [columns]="gridColumns$ | async"
  [options]="gridOptions$ | async"
></app-grid>
